<template>
    <div class="section-gameProvider" v-if="platforms.length">
        <div class="section-gameProvider__header">
            <h2>{{ $t('front.game.titles.providers') }}</h2>
            <div class="slider-nav">
                <router-link :to="seeAllPath">
                    {{ $t('front.game.button.see_all') }}
                    <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 11L6 6L1 1" stroke="#926D20"></path>
                    </svg>
                </router-link>
                <v-btn v-on:click="showPrev" class="prev" id="#button-prev-relacionadosXX">
                    <svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 1L2 5L6 9" stroke="white" stroke-width="1.5"/>
                        <path d="M2.5 5H10.5" stroke="white" stroke-width="1.5"/>
                    </svg>
                </v-btn>
                <v-btn v-on:click="showNext" class="next" id="#button-next-relacionadosXX">
                    <svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 1L9 5L5 9" stroke="white" stroke-width="1.5"/>
                        <path d="M8.5 5H0.5" stroke="white" stroke-width="1.5"/>
                    </svg>
                </v-btn>
            </div>
        </div>
        <div class="section-gameProvider__content">
            <swiper class="section-gameProvider__slider" ref="carousel" :options="settings" v-if="platforms.length">
                <swiper-slide class="item" v-for="(item, index) in platforms" :key="index">
                    <router-link :to="item.pageUrl">
                        <picture>
                            <source :data-srcset="item.logo[sourceType]" :type="`image/${sourceType}`"
                                    v-for="(sourceType, index) in item.logo.sourcesTypes" :key="index">
                            <img :data-src="item.logo.jpg" :alt="item.title"/>
                        </picture>
                    </router-link>
                </swiper-slide>
            </swiper>
        </div>
    </div>
</template>

<script>
import {Swiper, SwiperSlide} from "vue-awesome-swiper";
import apiData from "../../../../mixins/apiData";

export default {
    name: "GamePlatformsBar",

    components: {
        Swiper,
        SwiperSlide,
    },

    mixins: [apiData],

    data: function () {
        return {
            settings: {
                init: true,
                loop: true,
                slidesPerView: 1,
                direction: 'horizontal',
                spaceBetween: 0,
                speed: 500,
                navigation: {
                    nextEl: '#button-next-relacionadosXX',
                    prevEl: '#button-prev-relacionados',
                },
                breakpoints: {
                    320: {
                        slidesPerView: 6,
                    },
                    1200: {
                        slidesPerView: 8,
                    },
                }
            }
        };
    },

    serverPrefetch() {
        return this.fetchData();
    },

    mounted() {
        this.fetchData().then(() => setTimeout(() => {
            this.loadCurrentImages();
            this.swiper.on('beforeTransitionStart', this.loadCurrentImages);
        }, 100));
    },

    computed: {
        locale() {
            return this.$store.state.locale;
        },

        swiper() {
            return this.$refs.carousel && this.$refs.carousel.$swiper;
        },

        platforms() {
            return this.$store.state.baseDataGamePlatforms;
        },

        seeAllPath() {
            let languageUrlPrefix = this.$store.getters.getLanguageUrlPrefix();

            return `${languageUrlPrefix}/providers`;
        },

        showingSlidesCount() {
            return window.innerWidth > 1200 ? 8 : 6;
        }
    },

    methods: {
        fetchData() {
            return this.$store.dispatch('FETCH_BASE_DATA_GAME_PLATFORMS', this.createApiData());
        },

        showPrev() {
            this.swiper.slidePrev()
        },

        showNext() {
            this.swiper.slideNext()
        },

        loadCurrentImages() {
            let activeSlideIndex = this.swiper.activeIndex;

            for (let i = -1; i <= this.showingSlidesCount; i++) {
                let slide = this.swiper.slides[activeSlideIndex + i];

                if (slide && !slide.imageLoaded) {
                    this.loadImage(slide);
                    slide.imageLoaded = true;
                }
            }
        },

        loadImage(slide) {
            let slideSources = slide.getElementsByTagName('source');
            let slideImage = slide.getElementsByTagName('img')[0];

            slideImage.addEventListener('load', function () {
                this.parentElement.parentElement.parentElement.classList.add('load');
            });

            slideSources && Array.prototype.forEach.call(slideSources, slideSource => slideSource.setAttribute('srcset', slideSource.dataset.srcset));

            slideImage.setAttribute('src', slideImage.dataset.src);
        },
    },
}
</script>


<style lang="sass">
@import "sass/components/pages/parts/itemSets/GamePlatformsBar"
</style>
